import { render, staticRenderFns } from "./SelectGateways.vue?vue&type=template&id=12f8ae9a"
import script from "./SelectGateways.vue?vue&type=script&lang=js"
export * from "./SelectGateways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports